import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as selectors from './selectors';
import { utils as tmUtils } from './../team-management';

const allFilters = (state) => (
  tmUtils.serializeFilters(
    selectors.selectedFiltersSelector(state).selectedFilters,
  )
);

export const initialize = () => (dispatch, getState) => {
  const filters = allFilters(getState());
  return dispatch(actions.getInvitationList({ ...filters }));
};

export const updateTableOffset = (payload) => (dispatch, getState) => {
  const offset = (payload - 1) * PAGINATION_LIMIT;
  const filters = allFilters(getState());

  dispatch(actions.saveTableOffset(payload));
  dispatch(actions.getInvitationList({ offset, ...filters }));
};

export const toggleFilter = (payload) => (dispatch, getState) => {
  const filters = tmUtils.updateFilter(
    selectors.selectedFiltersSelector(getState()).selectedFilters.get(payload.label),
    payload.value,
  );

  dispatch(actions.updateFilter({ label: payload.label, value: filters }));

  const stateFilters = allFilters(getState());
  return dispatch(actions.getInvitationList({ ...stateFilters }))
    .then(() => dispatch(actions.toggleLoading(false)));
};

export const batchRenewInvitations = (payload) => (dispatch) => {
  if (!payload.size) {
    return dispatch(notificationActions.notifyWarning('You need to select invitations from table first'));
  }

  const reactivateInvitationRequests = payload
    .map((invitation) => dispatch(actions.renewInvitation(invitation.id)))
    .toArray();

  // FIXME: it will work for 2-4 changes at once, but wont for eg 100
  return Promise.all(reactivateInvitationRequests).then(
    () => Promise.all([
      dispatch(notificationActions.notifySuccess('Invitations renewed')),
      dispatch(actions.clearInvitationSelection()),
    ]),
    () => dispatch(notificationActions.notifyDanger('Something went wrong with renewing invitations')),
  );
};

export const batchRevokeInvitations = (payload) => (dispatch) => {
  if (!payload.size) {
    return dispatch(notificationActions.notifyWarning('You need to select invitations from table first'));
  }

  const reactivateInvitationRequests = payload
    .map((invitation) => dispatch(actions.revokeInvitation(invitation.id)))
    .toArray();

  // FIXME: it will work for 2-4 changes at once, but wont for eg 100
  return Promise.all(reactivateInvitationRequests).then(
    () => Promise.all([
      dispatch(notificationActions.notifySuccess('Invitations revoked')),
      dispatch(actions.clearInvitationSelection()),
    ]),
    () => dispatch(notificationActions.notifyDanger('Something went wrong with revoking invitations')),
  );
};
